var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2555_10251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 0.648438C9.42243 0.648438 0 10.0709 0 21.6484C0 33.226 9.42243 42.6484 21 42.6484C32.5776 42.6484 42 33.226 42 21.6484C42 10.0709 32.5776 0.648438 21 0.648438ZM21 41.2651C10.1842 41.2651 1.38329 32.4642 1.38329 21.6484C1.38329 10.8327 10.1842 2.03173 21 2.03173C31.8158 2.03173 40.6167 10.8327 40.6167 21.6484C40.6267 32.4642 31.8158 41.2651 21 41.2651Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4361 19.5234L17.6318 24.4151H21.2805L19.4963 19.5234H19.4361Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0518 11.8125H14.5148C14.0938 11.8125 13.7329 12.1734 13.7329 12.5944C13.7329 13.0154 14.0938 13.3762 14.5148 13.3762H29.2699V28.1915C29.2699 28.6125 29.6308 28.9734 30.0518 28.9734C30.4728 28.9734 30.8336 28.6125 30.8336 28.1915V12.5944C30.8336 12.1734 30.4728 11.8125 30.0518 11.8125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9718 14.8516H12.9508C11.9784 14.8516 11.1665 15.6434 11.1665 16.6358V29.6969C11.1665 30.6893 11.9584 31.4812 12.9508 31.4812H25.9718C26.9441 31.4812 27.756 30.6893 27.756 29.6969V16.6358C27.746 15.6434 26.9541 14.8516 25.9718 14.8516ZM22.5536 28.1933L21.6214 25.6072H17.3011L16.3488 28.1933H14.725L18.5942 18.1394H20.3383L24.2076 28.1933H22.5536Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2555_10251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 0.648438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.9db21ed2ea2d7b0df3fc26d49835fc87.svg";
export { ForwardRef as ReactComponent };